import Link, { LinkProps } from '@mui/material/Link';
import { styled } from '@mui/material/styles';

export const LinkPrimary = styled((props: LinkProps) => <Link {...props} />)(
    ({ theme }) => ({
        color: theme.palette.custom.customBlue,
        fontSize: theme.typography.linkPrimary.fontSize,
    })
);

export const LinkSecondary = styled((props: LinkProps) => <Link {...props} />)(
    ({ theme }) => ({
        color: theme.palette.custom.customGray,
        fontSize: theme.typography.linkSecondary.fontSize,
    })
);